import {Button, Form, Input, Modal} from 'antd';
import {FC} from 'react';
import {useTranslation} from 'react-i18next';
import {useMemoForm} from '../InventoryDetail/useMemoForm';

interface IInventoryMemoModalProps {
  date: string;
  open: boolean;
  onCancel: () => void;
}

const InventoryMemoModal: FC<IInventoryMemoModalProps> = ({
  date,
  open,
  onCancel,
}) => {
  const {t} = useTranslation();
  const {form, onSubmit} = useMemoForm({date, onCancel});
  return (
    <Modal
      open={open}
      onCancel={onCancel}
      title={t('Inventory detail')}
      footer={null}
    >
      <Form
        form={form}
        onFinish={onSubmit}
        autoComplete="off"
        labelCol={{span: 3, offset: 2}}
        wrapperCol={{span: 20}}
        labelAlign="left"
      >
        <Form.Item name="memo" label={t('Memo')}>
          <Input.TextArea placeholder={t('Enter memo')} />
        </Form.Item>

        <div style={{textAlign: 'center'}}>
          <Button type="primary" htmlType="submit">
            {t('Register')}
          </Button>
        </div>
      </Form>
    </Modal>
  );
};

export default InventoryMemoModal;
